import { render, staticRenderFns } from "./TrfcOutbound.vue?vue&type=template&id=2d6319c6&"
import script from "./TrfcOutbound.vue?vue&type=script&lang=js&"
export * from "./TrfcOutbound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports